import {RouteProps} from 'config/navigation';
import {MdOutlineSecurity} from 'react-icons/md';
import WhatsappDeliveryErrors from './whatsapp-delivery-errors';

const whatsappDeliveryErrorsPages: RouteProps = {
  name: 'Erros de confirmação',
  path: 'whatsapp-delivery-errors',
  permission: 'whatsappDeliveryErrors.findAll',
  icon: <MdOutlineSecurity />,
  subRoutes: [
    {
      path: '',
      element: <div />,
      permissions: ['whatsappDeliveryErrors.findAll'],
    },
  ],
};

export default whatsappDeliveryErrorsPages;
